











import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {}
})
class DataDictionary extends Vue {
  dicList = [
    {
      type: 'Investment Cost',
      name: '交割日期',
      desc: '法务文件中的交割日期'
    },
    {
      type: '',
      name: '财务交割日期',
      desc: '财务实际打款日期'
    },
    {
      type: 'Investment Cost',
      name: '本轮投资成本',
      desc: '法务文件中规定的本轮投资成本'
    },
    {
      type: '',
      name: '实际投资金额',
      desc: '财务实际的打款'
    },
    {
      type: '每股单价',
      name: '原始估值每股单价',
      desc: ' 投资时【交易文件post valuation/公司总股数】'
    },
    {
      type: '',
      name: '原始交易每股单价',
      desc: '投资时【该轮实际投资金额/该轮持有公司股数】'
    },
    {
      type: 'pre valuation',
      name: '交易文件投前估值',
      desc: '法务文件中规定的最新轮投前估值'
    },
    {
      type: '',
      name: '季度末财务评估投前估值',
      desc: '季度末财务综合评估该公司的投前估值'
    },
    {
      type: 'post valuation',
      name: '交易文件投后估值',
      desc: '法务文件中规定的最新轮投后估值'
    },
    {
      type: '',
      name: '季度末财务评估投后估值',
      desc: '季度末财务综合评估该公司的投后估值'
    },
    {
      type: 'Proceeds',
      name: '协议退出金额',
      desc: '投资时投后估值/公司股数'
    },
    {
      type: '',
      name: '实收退出金额',
      desc: '投资时实际投资金额/公司股数'
    },
    {
      type: '轮次',
      name: '项目所处轮次',
      desc: '该项目此次交易的轮次'
    },
    {
      type: '',
      name: '本轮交易轮次',
      desc: '该项目本轮实际交易股份的轮次'
    }
  ];
  columns = [
    {
      title: '字段类别',
      dataIndex: 'type'
    },
    {
      title: '具体字段名',
      dataIndex: 'name'
    },
    {
      title: '字段含义',
      dataIndex: 'desc'
    }
  ];
}
export default DataDictionary;
